import moment from 'moment';
import { Divider, Space, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { AiOutlineWhatsApp } from 'react-icons/ai';
import ItemData from '../Item';
import { formatPhone } from '../../../utils/bookings';
import { IBooking, IBookingEvent } from '../../../interfaces/booking.interface';
import { useWorkspaceStore } from '../../../store/workspace.store';

interface Props {
    type?: 'SUCCESS' | 'FAILED' | 'RESOLVING'
    booking: IBooking;
    bookingEvent: IBookingEvent;
}

const { Text } = Typography;

const AcceptedStatus = ({
    type = 'SUCCESS', booking, bookingEvent,
}: Props) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'DETAIL' });
    const workspace = useWorkspaceStore((state) => state.data);

    const phoneFormatted = bookingEvent?.driverMobile ? formatPhone(bookingEvent?.driverMobile, booking?.deliveryProvider) : null;

    const date = moment(bookingEvent?.createdAt).format('DD MMM HH:mm');
    const providerName = workspace?.name;

    return (
        <div className="booking__status--detail">
            <Space direction="vertical" size={4}>
                <Text className="booking__status--detail-title">
                    {t('STORY_LINE.EVENT_DETAILS')}
                </Text>

                <Text className={`booking__status--detail-tag ${type}`}>
                    {t(`STORY_LINE.${type}`)}
                </Text>
            </Space>

            <Text>
                <Trans
                    t={t}
                    i18nKey="STORY_LINE.STATUS.ACCEPTED_DESCRIPTION"
                    components={{ b: <b className="booking__status--bold" /> }}
                    values={{
                        driverName: bookingEvent.driverName,
                        deliveryProvider: providerName,
                        businessName: booking.businessName,
                        pickupAddress: booking.pickupAddress,
                    }}
                />
            </Text>

            {
                booking?.distance && booking?.eta && (
                    <Text>
                        <Trans
                            t={t}
                            i18nKey="STORY_LINE.STATUS.ACCEPTED_HELP"
                            components={{ b: <b className="booking__status--bold" /> }}
                            values={{
                                driverName: bookingEvent.driverName,
                                ETADistance: booking?.distance,
                                ETATime: booking?.eta,
                            }}
                        />
                    </Text>
                )
            }

            <Text className="booking__status--time">
                {date}
            </Text>

            <Divider />

            <Text className="booking__status--detail-subtitle">
                {t('STORY_LINE.INFORMATION')}
            </Text>

            <div className="booking__status--detail-info">
                <ItemData
                    label={t('DRIVER_NAME')}
                    value={bookingEvent.driverName}
                />
                <ItemData
                    label={t('DRIVER_MOBILE')}
                    value={phoneFormatted}
                    actionRequired={phoneFormatted !== null}
                    actionIcon={(
                        <AiOutlineWhatsApp
                            color="#6C8EEF"
                            size={16}
                            style={{ verticalAlign: 'middle' }}
                        />
                    )}
                    action={phoneFormatted !== null ? () => window.open(`https://wa.me/${phoneFormatted}`, '_blank') : () => {}}
                />
            </div>

        </div>
    );
};

export default AcceptedStatus;
